export default __webpack_public_path__ + "static/media/lotustoxindeadlyvenom.b83af415.png";